import { Icon } from '@types';

export const Trades = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="23.338"
			height="23.338"
			viewBox="0 0 23.338 23.338"
		>
			<defs>
				<clipPath id="clip-path-trade">
					<path
						id="Path_4228"
						data-name="Path 4228"
						d="M112.5,112.5h21.082v14.7H112.5Zm0,0"
						transform="translate(-112.5 -112.5)"
					/>
				</clipPath>
				<clipPath id="clip-path-trade-2">
					<path
						id="Path_4230"
						data-name="Path 4230"
						d="M127,168h21.082v14.7H127Zm0,0"
						transform="translate(-127 -168)"
					/>
				</clipPath>
				<clipPath id="clip-path-trade-3">
					<path
						id="Path_4232"
						data-name="Path 4232"
						d="M125,225h5.912v5.835H125Zm0,0"
						transform="translate(-125 -225)"
					/>
				</clipPath>
				<clipPath id="clip-path-trade-4">
					<path
						id="Path_4234"
						data-name="Path 4234"
						d="M212,112.5h5.912v5.835H212Zm0,0"
						transform="translate(-212 -112.5)"
					/>
				</clipPath>
			</defs>
			<g id="_8" data-name="8" transform="translate(-112.5 -112.5)">
				<path
					id="Path_4226"
					data-name="Path 4226"
					d="M155.835,161.669a5.835,5.835,0,1,1,5.835-5.835A5.84,5.84,0,0,1,155.835,161.669Zm0-10.7a4.862,4.862,0,1,0,4.862,4.862A4.868,4.868,0,0,0,155.835,150.972Zm0,0"
					transform="translate(-31.665 -31.665)"
				/>
				<g
					id="Group_4090"
					data-name="Group 4090"
					transform="translate(112.5 112.5)"
					clipPath="url(#clip-path-trade)"
				>
					<path
						id="Path_4227"
						data-name="Path 4227"
						d="M113.249,127.086a.486.486,0,0,1-.473-.379,11.527,11.527,0,0,1-.275-2.538A11.682,11.682,0,0,1,124.169,112.5a11.562,11.562,0,0,1,9.245,4.567.486.486,0,0,1-.772.591,10.6,10.6,0,0,0-8.473-4.185,10.709,10.709,0,0,0-10.7,10.7,10.583,10.583,0,0,0,.251,2.324.486.486,0,0,1-.368.582A.5.5,0,0,1,113.249,127.086Zm0,0"
						transform="translate(-112.5 -112.5)"
					/>
				</g>
				<g
					id="Group_4091"
					data-name="Group 4091"
					transform="translate(114.756 121.135)"
					clipPath="url(#clip-path-trade-2)"
				>
					<path
						id="Path_4229"
						data-name="Path 4229"
						d="M136.782,183.335a11.564,11.564,0,0,1-9.245-4.567.486.486,0,1,1,.772-.591,10.6,10.6,0,0,0,8.473,4.185,10.709,10.709,0,0,0,10.7-10.7,10.036,10.036,0,0,0-.259-2.318.486.486,0,1,1,.946-.225,11.07,11.07,0,0,1,.285,2.543A11.682,11.682,0,0,1,136.782,183.335Zm0,0"
						transform="translate(-127.369 -168.632)"
					/>
				</g>
				<g
					id="Group_4092"
					data-name="Group 4092"
					transform="translate(114.445 130.004)"
					clipPath="url(#clip-path-trade-3)"
				>
					<path
						id="Path_4231"
						data-name="Path 4231"
						d="M125.535,230.835a.487.487,0,0,1-.486-.481L125,225.491a.488.488,0,0,1,.486-.491h4.862a.486.486,0,0,1,0,.972h-4.371l.044,4.371a.486.486,0,0,1-.481.491Zm0,0"
						transform="translate(-125 -225)"
					/>
				</g>
				<g
					id="Group_4093"
					data-name="Group 4093"
					transform="translate(127.981 112.5)"
					clipPath="url(#clip-path-trade-4)"
				>
					<path
						id="Path_4233"
						data-name="Path 4233"
						d="M217.848,118.335h-4.862a.486.486,0,0,1,0-.972h4.376v-4.376a.486.486,0,0,1,.972,0v4.862A.487.487,0,0,1,217.848,118.335Zm0,0"
						transform="translate(-212.422 -112.5)"
					/>
				</g>
				<path
					id="Path_4235"
					data-name="Path 4235"
					d="M169.373,178.061a.491.491,0,0,1-.344-.142l-1.7-1.7a.486.486,0,0,1,.687-.687l1.332,1.332,2.818-3.252a.487.487,0,1,1,.735.638l-3.16,3.647a.489.489,0,0,1-.35.167Zm0,0"
					transform="translate(-46.176 -51.461)"
				/>
			</g>
		</svg>
	);
};
